import { cookies, getCookieDomain } from '../utils/cookie';
import { EVENTS, FUNNEL_STEP, FUNNEL_TYPES, track } from '../utils/tracking';
import config from '../config';

type OauthEventCookie = undefined | {
    type: 'login' | 'register';
    isSocial: string;
    clientId: string;
    socialProvider: string;
};

export default async function trackLoginWallInteractions() {
    const oauthEventCookieName = 'oauth2_latest_event';
    const oauthEvent = cookies.get(oauthEventCookieName) as OauthEventCookie;
    if (oauthEvent?.clientId !== config.auth.inlineClientId) return;

    const { type, isSocial } = oauthEvent;

    // Login-Wall Tracking
    if (type === 'login') {
        track({
            event: EVENTS.funnel,
            funnelType: FUNNEL_TYPES.application,
            funnelStep: FUNNEL_STEP.loginSuccess,
        });

        track({
            element: 'Login Step Success',
            elementDetail: isSocial ? 'social' : 'k.at',
        });
    } else if (type === 'register') {
        track({
            event: EVENTS.funnel,
            funnelType: FUNNEL_TYPES.application,
            funnelStep: FUNNEL_STEP.registerSuccess,
        });

        track({
            element: 'Register Step Success',
            elementDetail: isSocial ? 'social' : 'k.at',
        });
    }

    cookies.remove(oauthEventCookieName, { path: '/', domain: getCookieDomain() });
}
